import styled, { IFalconTheme, Scale, StyledComponent } from '@se-admin/falcon';

export const TextWrapperSmall: StyledComponent<'span', {}, {}> = styled('span')`
  margin: auto;
  padding-right: ${Scale.xxs};
`;

export const DiscountBadgeSmallStyle: StyledComponent<'span', IFalconTheme, {}> = styled('span')`
  border-radius: ${Scale.xxs};
  background-color: ${({ theme }) => theme.color.white};
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.fontFamilyBody.join(',')};
`;

export const CustomDiscountBadgeSmallStyle: StyledComponent<
  typeof DiscountBadgeSmallStyle,
  {},
  {}
> = styled(DiscountBadgeSmallStyle)`
  margin-left: ${Scale.xs};
`;
